import { PROFILE_UPDATE } from "../apiEndpoint";
import { educationAxios } from "../http/http";

export default function basicInfoUpdate(useremail, payload) {
  return educationAxios.put(
    `${PROFILE_UPDATE}?user_email=${useremail}`,
    payload
  );
}
